/**
 * 中国时区（Asia/Shanghai）日期工具
 * 请求参数中的「今天」以中国时区为准，与后端一致。
 */
var BUSINESS_TZ = 'Asia/Shanghai';
/**
 * 将 Date 格式化为中国时区的 YYYY-MM-DD
 */
export function formatDateInChina(date) {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: BUSINESS_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}
/**
 * 将 Unix 时间戳（秒）格式化为中国时区的 YYYY-MM-DD
 */
export function formatTimestampToChinaDate(timestampSeconds) {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: BUSINESS_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(new Date(timestampSeconds * 1000));
}
/**
 * 将 YYYY-MM-DD 解析为中国时区该日 00:00:00 的 Date
 */
export function parseChinaDate(dateStr) {
    return new Date("".concat(dateStr, "T00:00:00+08:00"));
}
/**
 * 中国时区「今天」零点的 Unix 时间戳（秒），用于请求参数
 */
export function getTodayStartInChinaSeconds() {
    var todayStr = formatDateInChina(new Date());
    return Math.floor(new Date("".concat(todayStr, "T00:00:00+08:00")).getTime() / 1000);
}
/**
 * 中国时区「上一营业日」的 YYYY-MM-DD（业务报告接口只支持到上一营业日，不支持当天）
 */
export function getYesterdayStrInChina() {
    return formatTimestampToChinaDate(getTodayStartInChinaSeconds() - 86400);
}
/**
 * 将 Date 格式化为中国时区的日期时间字符串（YYYY/M/D HH:mm:ss），用于展示
 */
export function formatDateTimeInChina(date) {
    var formatter = new Intl.DateTimeFormat('zh-CN', {
        timeZone: BUSINESS_TZ,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
    return formatter.format(date).replaceAll(/\s/g, ' ');
}
/**
 * 获取中国时区下该时刻的小时数（0–23）
 */
export function getChinaHour(date) {
    var _a, _b;
    var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: BUSINESS_TZ,
        hour: 'numeric',
        hour12: false,
    }).formatToParts(date);
    return Number.parseInt((_b = (_a = parts.find(function (p) { return p.type === 'hour'; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '0', 10);
}
/**
 * 将 Unix 时间戳（秒）解析为中国时区的年/月/日，用于同期对齐（避免浏览器时区导致错位）
 */
export function getChinaDateParts(timestampSeconds) {
    var _a, _b, _c, _d, _e, _f;
    var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: BUSINESS_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(new Date(timestampSeconds * 1000));
    var year = Number.parseInt((_b = (_a = parts.find(function (p) { return p.type === 'year'; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '0', 10);
    var month = Number.parseInt((_d = (_c = parts.find(function (p) { return p.type === 'month'; })) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '0', 10) - 1; // 0-based
    var day = Number.parseInt((_f = (_e = parts.find(function (p) { return p.type === 'day'; })) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '0', 10);
    return { year: year, month: month, day: day };
}
